export function targetScrollLeft(container, active, padding = 8) {
  if (!container || !active) return null

  const current = container.scrollLeft
  const viewportStart = current + padding
  const viewportEnd = current + container.clientWidth - padding
  const itemStart = active.offsetLeft
  const itemEnd = itemStart + active.offsetWidth

  let target = current
  if (itemStart < viewportStart) {
    target = itemStart - padding
  } else if (itemEnd > viewportEnd) {
    target = itemEnd - container.clientWidth + padding
  }

  const maximum = Math.max(0, container.scrollWidth - container.clientWidth)
  return Math.min(maximum, Math.max(0, target))
}

export function revealActiveItem(container, active) {
  const left = targetScrollLeft(container, active)
  if (left === null || left === container.scrollLeft) return false

  container.scrollTo({ left, behavior: "auto" })
  return true
}
